import React, { Component } from "react";
import { withRouter } from "./withRouter";
import { Popup } from "react-map-gl";

class NZ2026HomeTooltip extends Component {

  buildTooltip(hoverInfo, styledGeo, tooltip_pastcomp) {
    const { geoLevel } = this.props;
    if (!hoverInfo) return null;
    if (!styledGeo) return null;
    const { area_name, area_id } = hoverInfo.props;

    // Find matching feature in styledGeo
    const comparatorFeature = styledGeo.features.find(
      f => f.properties.area_id === area_id
    );

    // Predicted vote shares (current prediction)
    const predictedValues = JSON.parse(hoverInfo.props._allValuesSorted);

    // Wave-on-wave diffs
    const hasPrevWave = hoverInfo.props._hasPrevWave === true || hoverInfo.props._hasPrevWave === "true";
    let diffByKey = {};
    if (hasPrevWave && hoverInfo.props._diffValuesSorted) {
      const diffValues = typeof hoverInfo.props._diffValuesSorted === "string"
        ? JSON.parse(hoverInfo.props._diffValuesSorted)
        : hoverInfo.props._diffValuesSorted;
      for (const d of diffValues) {
        diffByKey[d.key] = d.area_id;
      }
    }

    const partyConfig = {
      nat_pred_n: { label: "National", color: "#0056A8" },
      act_pred_n: { label: "ACT", color: "#FFD700" },
      nzf_pred_n: { label: "NZF", color: "#000000" },
      lab_pred_n: { label: "Labour", color: "#E82C2C" },
      green_pred_n: { label: "Green", color: "#009639" },
      tpm_pred_n: { label: "TPM", color: "#CC0033" },
      oth_pred_n: { label: "Other", color: "#999999" },
      coalition: { label: "Coalition", color: "" }
    };

    // Build vote share lines / current predicted value
    let voteLines;
    if (this.props.chosenParty === "coalition") {
      const nat = predictedValues.find(d => d.key === "nat_pred_n")?.area_id || 0;
      const act = predictedValues.find(d => d.key === "act_pred_n")?.area_id || 0;
      const nzf = predictedValues.find(d => d.key === "nzf_pred_n")?.area_id || 0;
      voteLines = nat + act + nzf;
    } else {
      voteLines = predictedValues.find(d => d.key === this.props.chosenParty)?.area_id || 0;
    }

    // Get "previous" vote (for comparison)
    let vote2023 = 0;
    if (this.props.chosenParty === "coalition") {
      if (tooltip_pastcomp === "no") {
        const nat = comparatorFeature?.properties?.past_vote_nat || 0;
        const act = comparatorFeature?.properties?.past_vote_act || 0;
        const nzf = comparatorFeature?.properties?.past_vote_nzf || 0;
        vote2023 = nat + act + nzf;
      } else {
        const nat = comparatorFeature?.properties?.nat_pred_n || 0;
        const act = comparatorFeature?.properties?.act_pred_n || 0;
        const nzf = comparatorFeature?.properties?.nzf_pred_n || 0;
        vote2023 = (nat + act + nzf) * 100;
      }
    } else {
      if (tooltip_pastcomp === "no") {
        const pastKey = this.props.chosenParty.replace("_pred_n", "").replace(/^/, "past_vote_");
        vote2023 = comparatorFeature?.properties?.[pastKey] || 0;
      } else {
        vote2023 = (comparatorFeature?.properties?.[this.props.chosenParty] || 0) * 100;
      }
    }

    // Wave-on-wave diff for chosen party
    let waveDiff = null;
    if (hasPrevWave) {
      if (this.props.chosenParty === "coalition") {
        const natDiff = diffByKey["nat_pred_n"] ?? 0;
        const actDiff = diffByKey["act_pred_n"] ?? 0;
        const nzfDiff = diffByKey["nzf_pred_n"] ?? 0;
        waveDiff = natDiff + actDiff + nzfDiff;
      } else if (diffByKey[this.props.chosenParty] !== undefined) {
        waveDiff = diffByKey[this.props.chosenParty];
      }
    }

    let area_type_label;
    switch (geoLevel) {
      case "constituency":
        area_type_label = "Electorate";
        break;
      default:
        area_type_label = geoLevel;
        break;
    }

    const change_since23 = (voteLines?.toFixed(0) - vote2023?.toFixed(0));

    return (
      <>
        {voteLines && (
          <div style={{ fontSize: "13px" }}>
            <strong>{area_name}</strong> {area_type_label}
            <br />
            {partyConfig[this.props.chosenParty].label} vote share: <b>{voteLines.toFixed(0)}</b>%{" "}
            ({change_since23 > 0 ? "+" : ""}{change_since23}% since 2023)
            {waveDiff !== null && (
              <> [{waveDiff > 0 ? "+" : ""}{waveDiff.toFixed(0)}% since last wave]</>
            )}
          </div>
        )}
      </>
    );
  }

  render() {
    const { styledGeo, hoverInfo } = this.props;

    return (
      <>
        {styledGeo && hoverInfo && hoverInfo?.props?.topValue && (
          <Popup
            longitude={hoverInfo.lon}
            latitude={hoverInfo.lat}
            closeButton={false}
            closeOnClick={false}
            offset={12}
            dynamicPosition={true}
            maxWidth="500px"
          >
            {this.buildTooltip(hoverInfo, styledGeo, this.props.tooltip_pastcomp)}
          </Popup>
        )}
      </>
    );
  }
}

export default withRouter(NZ2026HomeTooltip);